import EmailRounded from '@mui/icons-material/EmailRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Button, IconButton, Stack, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useAuth } from '../../auth/AuthProvider';
import type { Channel } from './api';
import { SendMessageDialog, WHATSAPP_GREEN } from './SendMessageDialog';
import type { TemplateKind } from './templates';

/**
 * WhatsApp and Email buttons that message a shop from PackBytes' own accounts, starting from the
 * Settings templates (support inbox conversations, the tenant page).
 */
export function MessageButtons({
  tenant,
  prefer,
  template = 'tenant',
  compact = false,
}: {
  tenant: { id: string; name: string };
  /** Which Settings template set the popups start with. */
  template?: TemplateKind;
  prefer?: { phone?: string | null; email?: string | null };
  compact?: boolean;
}) {
  const { can } = useAuth();
  const [open, setOpen] = useState<Channel | null>(null);
  if (!can('support.chat')) return null;
  return (
    <>
      {compact ? (
        <Stack direction="row" spacing={0.25}>
          <Tooltip title="Send a WhatsApp message">
            <IconButton aria-label="Send WhatsApp" onClick={() => setOpen('WHATSAPP')}>
              <WhatsAppIcon sx={{ color: WHATSAPP_GREEN }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Send an email">
            <IconButton aria-label="Send email" onClick={() => setOpen('EMAIL')}>
              <EmailRounded />
            </IconButton>
          </Tooltip>
        </Stack>
      ) : (
        <>
          <Button
            variant="outlined"
            startIcon={<WhatsAppIcon sx={{ color: WHATSAPP_GREEN }} />}
            onClick={() => setOpen('WHATSAPP')}
          >
            WhatsApp
          </Button>
          <Button variant="outlined" startIcon={<EmailRounded />} onClick={() => setOpen('EMAIL')}>
            Email
          </Button>
        </>
      )}
      {open && (
        <SendMessageDialog
          tenant={tenant}
          channel={open}
          template={template}
          prefer={prefer}
          onClose={() => setOpen(null)}
        />
      )}
    </>
  );
}
